module.exports = __webpack_public_path__ + "img/img-doctor-picture-b.c0a82ede.png";